module.exports = __webpack_public_path__ + "static/img/cyfw_index_3_1.e21f45c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cyfw_index_3_1.png
// module id = kiAL
// module chunks = 1